import React from 'react'
import CookieConsent from 'react-cookie-consent'
import {Link} from 'react-router-dom'

export const CookieConsentComponent = () => {
	return <CookieConsent
		location="bottom"
		buttonText="Приемам"
		style={{ background: 'rgba(40, 40, 68, .9)' }}
		buttonStyle={{ color: '#fff', background: '#f7931a' }}
		expires={150}
		onAccept={() => { }}
	>
    Tози сайт използва "Бисквитки". Научи повече <Link to={'/cookie-policy'} className='u-text--cornflower'>тук</Link>.
	</CookieConsent>
}

export default CookieConsentComponent
